import { Stack, Typography } from "@mui/material"

 type PreviewPromptTabProps = {
    systemPrompt: string[]
    promptText: string
}

export const PreviewPromptTab = ({systemPrompt, promptText}: PreviewPromptTabProps) => {

    return (
        <Stack className='PreviewPromptContainer'>
            <Typography className='SystemPromptText'>
                {systemPrompt[0]}
            </Typography>
            <Typography className='CustomPromptText'>
                {promptText.length > 0 ? promptText : 'your custom prompt text appear here'}
            </Typography>
            <Typography className='SystemPromptText'>
                {systemPrompt[1]}
            </Typography>
        </Stack>
    )
}
